var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 26,
    viewBox: "0 0 43 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4346 0.51706L42.4911 11.7517C43.1696 12.4411 43.1696 13.5589 42.4911 14.2483L31.4346 25.4829C30.7561 26.1724 29.656 26.1724 28.9775 25.4829C28.2991 24.7935 28.2991 23.6758 28.9775 22.9864L37.0682 14.7654H0V11.2346H37.0682L28.9775 3.01365C28.2991 2.32423 28.2991 1.20647 28.9775 0.51706C29.656 -0.172353 30.7561 -0.172353 31.4346 0.51706Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.965cf93a523af3adeb093ceeb7d1638e.svg";
export { ForwardRef as ReactComponent };